import Vue from 'vue'

/**
 * Capitalize the first letter of the first word
 * Example: hello => Hello
 *
 * @param {String} vallue
 * @return {String}
 */
Vue.filter('capitalize', function (value) {
  if (!value) {
    return ''
  }

  value = value.toString().toLowerCase()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

/**
 * Formats a phone number.
 * Example: 123-456-7890 => (123) 456-7890
 *
 * @param {String} phone
 * @return {String}
 */
Vue.filter('phone', function (phone) {
  if (!phone) {
    return ''
  }

  return phone.replace(/[^0-9]/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
})

/**
 * Formats a number into a dollar format
 * Example: 10000 => $10,000.00
 *
 * @param {String} value
 * @return {String}
 */
Vue.filter('dollar', function (amount) {
  if (isNaN(amount)) {
    return amount
  }

  const numeral = require('numeral')
  return numeral(amount).format('$0,0.00')
})

/**
 * Formats a number using numeral formatting
 *
 * @param {String} value
 * @return {String}
 */
Vue.filter('numeral', function (value, format) {
  if (isNaN(value)) {
    return value
  }

  const numeral = require('numeral')
  return numeral(value).format(format)
})
